import RadioControl from '@/features/ui/inputs/components/RadioButton/parts/RadioControl'
import Typography from '@/features/ui/typography'
import { ComponentType, FC } from 'react'
import { Pressable, StyleSheet, View } from 'react-native'
import { SvgProps } from 'react-native-svg'

interface RadioItemProps {
    label: string
    LabelIcon: ComponentType<SvgProps>
    checked: boolean
    onChange: (newChecked: boolean) => void
    disabled?: boolean
}

const RadioItem: FC<RadioItemProps> = ({ label, LabelIcon, checked, onChange, disabled }) => {
    const handlePress = () => {
        onChange(!checked)
    }

    return (
        <Pressable disabled={disabled} onPress={handlePress} style={styles.container}>
            <RadioControl checked={checked} disabled={disabled} />
            <View style={styles.label}>
                <LabelIcon />
                <Typography.Heading variant="h5">{label}</Typography.Heading>
            </View>
        </Pressable>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        gap: 8,
        alignItems: 'center',
    },
    label: {
        flexDirection: 'row',
        gap: 4,
        alignItems: 'center',
    },
})

export default RadioItem
